import Blockly from 'blockly'

const blocks = [
  // Block for if/elseif/else condition.
  {
    type: 'controls_if',
    message0: '%{BKY_CONTROLS_IF_MSG_IF} %1',
    args0: [
      {
        type: 'input_value',
        name: 'IF0',
        check: 'Boolean'
      }
    ],
    message1: '%{BKY_CONTROLS_IF_MSG_THEN} %1',
    args1: [
      {
        type: 'input_statement',
        name: 'DO0'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    style: 'loop_blocks',
    helpUrl: '%{BKY_CONTROLS_IF_HELPURL}',
    mutator: 'controls_if_mutator',
    extensions: ['controls_if_tooltip']
  },
  // If/else block that does not use a mutator.
  {
    type: 'controls_ifelse',
    message0: '%{BKY_CONTROLS_IF_MSG_IF} %1',
    args0: [
      {
        type: 'input_value',
        name: 'IF0',
        check: 'Boolean'
      }
    ],
    message1: '%{BKY_CONTROLS_IF_MSG_THEN} %1',
    args1: [
      {
        type: 'input_statement',
        name: 'DO0'
      }
    ],
    message2: '%{BKY_CONTROLS_IF_MSG_ELSE} %1',
    args2: [
      {
        type: 'input_statement',
        name: 'ELSE'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    style: 'loop_blocks',
    tooltip: '%{BKYCONTROLS_IF_TOOLTIP_2}',
    helpUrl: '%{BKY_CONTROLS_IF_HELPURL}',
    extensions: ['controls_if_tooltip']
  },
  // Block representing the if statement in the controls_if mutator.
  {
    type: 'controls_if_if',
    message0: '%{BKY_CONTROLS_IF_IF_TITLE_IF}',
    nextStatement: null,
    enableContextMenu: false,
    style: 'loop_blocks',
    tooltip: '%{BKY_CONTROLS_IF_IF_TOOLTIP}'
  },
  // Block representing the else-if statement in the controls_if mutator.
  {
    type: 'controls_if_elseif',
    message0: '%{BKY_CONTROLS_IF_ELSEIF_TITLE_ELSEIF}',
    previousStatement: null,
    nextStatement: null,
    enableContextMenu: false,
    style: 'loop_blocks',
    tooltip: '%{BKY_CONTROLS_IF_ELSEIF_TOOLTIP}'
  },
  // Block representing the else statement in the controls_if mutator.
  {
    type: 'controls_if_else',
    message0: '%{BKY_CONTROLS_IF_ELSE_TITLE_ELSE}',
    previousStatement: null,
    enableContextMenu: false,
    style: 'loop_blocks',
    tooltip: '%{BKY_CONTROLS_IF_ELSE_TOOLTIP}'
  },
  {
    type: 'math_number_property',
    message0: '%1 %2',
    args0: [
      {
        type: 'input_value',
        name: 'NUMBER_TO_CHECK',
        check: 'Number'
      },
      {
        type: 'field_dropdown',
        name: 'PROPERTY',
        options: [
          ['%{BKY_MATH_IS_EVEN}', 'EVEN'],
          ['%{BKY_MATH_IS_ODD}', 'ODD'],
          ['%{BKY_MATH_IS_PRIME}', 'PRIME'],
          ['%{BKY_MATH_IS_WHOLE}', 'WHOLE'],
          ['%{BKY_MATH_IS_POSITIVE}', 'POSITIVE'],
          ['%{BKY_MATH_IS_NEGATIVE}', 'NEGATIVE'],
          ['%{BKY_MATH_IS_DIVISIBLE_BY}', 'DIVISIBLE_BY']
        ]
      }
    ],
    inputsInline: true,
    output: 'Boolean',
    style: 'logic_blocks',
    tooltip: '%{BKY_MATH_IS_TOOLTIP}',
    mutator: 'math_is_divisibleby_mutator'
  },
  {
    type: 'lists_isEmpty',
    message0: '%{BKY_LISTS_ISEMPTY_TITLE}',
    args0: [
      {
        type: 'input_value',
        name: 'VALUE',
        check: ['String', 'Array']
      }
    ],
    output: 'Boolean',
    style: 'logic_blocks',
    tooltip: '%{BKY_LISTS_ISEMPTY_TOOLTIP}',
    helpUrl: '%{BKY_LISTS_ISEMPTY_HELPURL}'
  },
  {
    type: 'text_isEmpty',
    message0: '%{BKY_TEXT_ISEMPTY_TITLE}',
    args0: [
      {
        type: 'input_value',
        name: 'VALUE',
        check: ['String', 'Array']
      }
    ],
    output: 'Boolean',
    style: 'logic_blocks',
    tooltip: '%{BKY_TEXT_ISEMPTY_TOOLTIP}',
    helpUrl: '%{BKY_TEXT_ISEMPTY_HELPURL}'
  },

  {
    type: 'controls_forEach',
    message0: '%{BKY_CONTROLS_FOREACH_TITLE}',
    args0: [
      {
        type: 'field_variable',
        name: 'VAR',
        variable: null
      },
      {
        type: 'input_value',
        name: 'LIST',
        check: 'Array'
      }
    ],
    message1: '%{BKY_CONTROLS_REPEAT_INPUT_DO} %1',
    args1: [
      {
        type: 'input_statement',
        name: 'DO'
      }
    ],
    inputsInline: true,
    previousStatement: null,
    nextStatement: null,
    style: 'loop_blocks',
    helpUrl: '%{BKY_CONTROLS_FOREACH_HELPURL}',
    extensions: ['contextMenu_newGetVariableBlock', 'controls_forEach_tooltip']
  },
  {
    type: 'controls_whileUntil',
    message0: '%{BKY_CONTROLS_WHILEUNTIL_TITLE}',
    args0: [
      {
        type: 'field_dropdown',
        name: 'MODE',
        options: [
          ['%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_WHILE}', 'WHILE'],
          ['%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_UNTIL}', 'UNTIL']
        ]
      },
      {
        type: 'input_value',
        name: 'BOOL',
        check: 'Boolean'
      }
    ],
    message1: '%{BKY_CONTROLS_REPEAT_INPUT_DO} %1',
    args1: [
      {
        type: 'input_statement',
        name: 'DO'
      }
    ],
    inputsInline: true,
    previousStatement: null,
    nextStatement: null,
    style: 'loop_blocks',
    helpUrl: '%{BKY_CONTROLS_WHILEUNTIL_HELPURL}',
    extensions: ['controls_whileUntil_tooltip']
  },
  {
    type: 'text_length',
    message0: '%{BKY_TEXT_LENGTH_TITLE}',
    args0: [
      {
        type: 'input_value',
        name: 'VALUE',
        check: ['String', 'Array']
      }
    ],
    inputsInline: true,
    output: 'Number',
    style: 'text_blocks',
    tooltip: '%{BKY_TEXT_LENGTH_TOOLTIP}',
    helpUrl: '%{BKY_TEXT_LENGTH_HELPURL}'
  },
  {
    type: 'text_indexOf',
    message0: '%{BKY_TEXT_INDEXOF_TITLE}',
    args0: [
      {
        type: 'input_value',
        name: 'VALUE',
        check: 'String'
      },
      {
        type: 'input_value',
        name: 'FIND',
        check: 'String'
      },
      {
        type: 'field_dropdown',
        name: 'END',
        options: [
          ['%{BKY_TEXT_INDEXOF_OPERATOR_FIRST}', 'FIRST'],
          ['%{BKY_TEXT_INDEXOF_OPERATOR_LAST}', 'LAST']
        ]
      }
    ],
    output: 'Number',
    style: 'text_blocks',
    helpUrl: '%{BKY_TEXT_INDEXOF_HELPURL}',
    inputsInline: true,
    extensions: ['text_indexOf_tooltip']
  },
  {
    type: 'logic_ternary',
    message0: '%{BKY_LOGIC_TERNARY_CONDITION} %1',
    args0: [
      {
        type: 'input_value',
        name: 'IF',
        check: 'Boolean'
      }
    ],
    message1: '%{BKY_LOGIC_TERNARY_IF_TRUE} %1',
    args1: [
      {
        type: 'input_value',
        name: 'THEN'
      }
    ],
    message2: '%{BKY_LOGIC_TERNARY_IF_FALSE} %1',
    args2: [
      {
        type: 'input_value',
        name: 'ELSE'
      }
    ],
    inputsInline: true,
    output: null,
    style: 'logic_blocks',
    tooltip: '%{BKY_LOGIC_TERNARY_TOOLTIP}',
    helpUrl: '%{BKY_LOGIC_TERNARY_HELPURL}',
    extensions: ['logic_ternary']
  },
  {
    type: 'math_on_list',
    message0: '%{BKY_MATH_ON_LIST_TITLE}',
    args0: [
      {
        type: 'input_value',
        name: 'LIST',
        check: 'Array'
      },
      {
        type: 'field_dropdown',
        name: 'OP',
        options: [
          ['%{BKY_MATH_ONLIST_OPERATOR_SUM}', 'SUM'],
          ['%{BKY_MATH_ONLIST_OPERATOR_MIN}', 'MIN'],
          ['%{BKY_MATH_ONLIST_OPERATOR_MAX}', 'MAX'],
          ['%{BKY_MATH_ONLIST_OPERATOR_AVERAGE}', 'AVERAGE'],
          ['%{BKY_MATH_ONLIST_OPERATOR_MEDIAN}', 'MEDIAN'],
          ['%{BKY_MATH_ONLIST_OPERATOR_MODE}', 'MODE'],
          ['%{BKY_MATH_ONLIST_OPERATOR_STD_DEV}', 'STD_DEV'],
          ['%{BKY_MATH_ONLIST_OPERATOR_RANDOM}', 'RANDOM']
        ]
      }
    ],
    output: 'Number',
    style: 'math_blocks',
    helpUrl: '%{BKY_MATH_ONLIST_HELPURL}',
    mutator: 'math_modes_of_list_mutator',
    extensions: ['math_op_tooltip']
  },
  {
    type: 'text_join',
    message0: '',
    inputsInline: true,
    output: 'String',
    style: 'text_blocks',
    helpUrl: '%{BKY_TEXT_JOIN_HELPURL}',
    tooltip: '%{BKY_TEXT_JOIN_TOOLTIP}',
    mutator: 'text_join_mutator'
  }
]

const updateBlocks = function (jsonArray) {
  Blockly.Msg.PROCEDURES_DEFNORETURN_COMMENT = ''
  for (let i = 0; i < jsonArray.length; i++) {
    let elem = jsonArray[i]
    let typename = elem.type
    Blockly.Blocks[typename] = {
      init: Blockly.jsonInitFactory_(elem)
    }
  }
}

// preventing math_change block, it uses numbers module
Blockly.Variables.flyoutCategoryBlocks = function (workspace) {
  let variableModelList = workspace.getVariablesOfType('')
  let xmlList = []
  if (variableModelList.length > 0) {
    // New variables are added to the end of the variableModelList.
    let mostRecentVariable = variableModelList[variableModelList.length - 1]
    if (Blockly.Blocks['variables_set']) {
      let block = Blockly.utils.xml.createElement('block')
      block.setAttribute('type', 'variables_set')
      block.setAttribute('gap', Blockly.Blocks['variables_get'] ? 8 : 24)
      block.appendChild(
        Blockly.Variables.generateVariableFieldDom(mostRecentVariable)
      )
      xmlList.push(block)
    }
    if (Blockly.Blocks['variables_get']) {
      variableModelList.sort(Blockly.VariableModel.compareByName)
      for (let i = 0, variable; (variable = variableModelList[i]); i++) {
        let block = Blockly.utils.xml.createElement('block')
        block.setAttribute('type', 'variables_get')
        block.setAttribute('gap', 8)
        block.appendChild(Blockly.Variables.generateVariableFieldDom(variable))
        xmlList.push(block)
      }
    }
  }
  return xmlList
}

let shouldStartNewRow =
  Blockly.blockRendering.RenderInfo.prototype.shouldStartNewRow_
Blockly.blockRendering.RenderInfo.prototype.shouldStartNewRow_ = function (
  input,
  lastInput
) {
  if (input.type == Blockly.DUMMY_INPUT && input.name == 'ROW_LINEBREAK') {
    return true
  }
  return shouldStartNewRow.call(this, input, lastInput)
}

Blockly.FieldCheckbox.prototype.initView = function () {
  Blockly.FieldCheckbox.superClass_.initView.call(this)
  this.borderRect_.classList.add('ifblockCheckBox')
  if (this.value_) this.borderRect_.classList.add('ifblockChecked')
  else this.borderRect_.classList.remove('ifblockChecked')
}

Blockly.FieldCheckbox.prototype.doValueUpdate_ = function (newValue) {
  this.value_ = this.convertValueToBool_(newValue)
  if (this.borderRect_) {
    if (this.value_) this.borderRect_.classList.add('ifblockChecked')
    else this.borderRect_.classList.remove('ifblockChecked')
  }
}

updateBlocks(blocks)
